var _defs, _path, _mask;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0.667969,0.666016 H 16.8986 V 16.8968 H 0.667969 Z",
    fill: "#ffffff",
    id: "path5"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 8.7838,1.91602 c -3.78583,0 -6.86583,3.07916 -6.86583,6.865 0,3.78578 3.08,6.86578 6.86583,6.86578 3.785,0 6.865,-3.08 6.865,-6.86578 0,-3.78584 -3.08,-6.865 -6.865,-6.865 m 0,14.98078 c -4.475,0 -8.115831,-3.6408 -8.115831,-8.11578 0,-4.475 3.640831,-8.115004 8.115831,-8.115004 4.475,0 8.115,3.640004 8.115,8.115004 0,4.47498 -3.64,8.11578 -8.115,8.11578",
    fill: "#5d6373",
    id: "path2",
    mask: "url(#mask5)",
    transform: "matrix(1.05,0,0,1.05,-0.21219657,-0.23686654)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_633_5472",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 5,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 13.3672,13.7559 h 4.1867 v 4.1789 h -4.1867 z",
    fill: "#ffffff",
    id: "path3"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans",
      fill: "#5d5d75",
      strokeWidth: 1.05
    },
    d: "m 8.0918755,12.056702 h 1.2489257 v 1.562695 H 8.0918755 Z M 9.3038872,11.152307 H 8.1287896 v -0.947461 q 0,-0.6213864 0.1722656,-1.0212888 0.1722656,-0.3999023 0.7259765,-0.9290039 l 0.553711,-0.5475586 q 0.3506835,-0.3260741 0.5044923,-0.6152344 0.159961,-0.2891601 0.159961,-0.590625 0,-0.5475585 -0.4060549,-0.8859375 Q 9.4392387,5.276819 8.7747856,5.276819 q -0.4860351,0 -1.039746,0.215332 Q 7.187481,5.7074831 6.5907036,6.1196901 V 4.9630494 Q 7.169024,4.6123658 7.759649,4.4401002 8.3564262,4.2678346 8.9901177,4.2678346 q 1.1320303,0 1.8149413,0.5967773 0.689062,0.5967774 0.689062,1.575 0,0.4675782 -0.221483,0.8920899 -0.221485,0.4183594 -0.775196,0.9474609 L 9.9560356,8.8082643 Q 9.6668755,9.0974244 9.5438286,9.2635377 9.4269341,9.4234987 9.3777153,9.5773072 9.3408012,9.7065065 9.3223442,9.8910768 9.3038872,10.075647 9.3038872,10.395569 Z",
    id: "text6",
    "aria-label": "?"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fbc9d76192437162c4b22626b8a4b9f5.svg";
export { ForwardRef as ReactComponent };